<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
       {{ $t('Upload file') }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <file-upload :description="description" :unzipContent="false" @uploaded="fileUploaded" @started="uploadStarted"/>
            <div v-if="fileMeta">{{ $t('Filename') }}: {{fileMeta.originalName}}</div>
          </v-col>
          <v-col cols="12">
            <v-text-field :label="$t('Description')" v-model="description"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="tags"
              :items="fileTags"
              filled
              chips
              label="Tags"
              item-text="name"
              item-value="id"
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  :color="data.item.color"
                  text-color="white"
                  @click="data.select"
                  @click:close="removeTag(data.item)"
                >
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-content class="ma-0">
                  <v-list-item-title>
                    <v-chip
                      v-html="data.item.name"
                      class="ma-0"
                      :color="data.item.color"
                      text-color="white"
                    />
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          text
          @click="close"
        >
         {{ $t('Cancel') }}
        </v-btn>
        <v-btn
          :disabled="!isValid"
          color="primary"
          text
          @click="doConfirm"
        >
          {{ $t('Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FileUpload from "@/components/FileUpload";

export default {
  name: 'CourseUploadDialog',
  components: {FileUpload},
  props: {
    allTags: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showDialog: false,
      resolve: null,
      description: '',
      tags: [],
      isValid: false,
      fileMeta: undefined,
    }
  },
  computed: {
    fileTags() {
      return (this.allTags || []).filter(tag => tag && tag.type === 'file')
    }
  },
  methods: {
    show () {
      this.description = ''
      this.tags = []
      this.isValid = false
      this.showDialog = true
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    doConfirm () {
      this.close()
      console.log(this.fileMeta)
      const file = {...this.fileMeta}
      this.fileMeta = undefined
      this.resolve({file, description: this.description, tags: this.tags})
    },
    close() {
      this.showDialog = false
    },
    removeTag(item) {
      const index = this.tags.indexOf(item.id)
      if (index >= 0) this.tags.splice(index, 1)
    },
    fileUploaded(fileMeta) {
      console.log("File uploaded", fileMeta)
      this.isValid = true
      this.fileMeta = fileMeta

      // Titel aus Dateinamen generieren, falls noch keine Beschreibung da ist
      if (fileMeta && fileMeta.originalName && !this.description) {
        // 1. Endung entfernen (alles nach dem letzten Punkt)
        let name = fileMeta.originalName.substring(0, fileMeta.originalName.lastIndexOf('.')) || fileMeta.originalName;
        
        // 2. Unterstriche und Bindestriche durch Leerzeichen ersetzen
        name = name.replace(/[_-]/g, ' ');
        
        // 3. Überflüssige Leerzeichen entfernen (falls z.B. -- verwendet wurde)
        this.description = name.replace(/\s+/g, ' ').trim();
      }
    },
    uploadStarted() {
      this.isValid = false
    },
  },
}
</script>

<style scoped>
.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  transition: all 0.3s ease;
  background-color: rgba(0, 0, 0, 0.02);
}

.drop-zone--active {
  border-color: #03a9f4;
  background-color: rgba(3, 169, 244, 0.05);
}
</style>
